const AI_NETWORK_IMG =
  "https://images.unsplash.com/photo-1765816589173-d87bf0c38e71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxjcmVhdGl2ZSUyMG5ldHdvcmslMjBub2RlcyUyMHRlY2hub2xvZ3l8ZW58MHx8fHwxNzc3NjQyMTg4fDA&ixlib=rb-4.1.0&q=85";

export default function AITravel() {
  const aiCapabilities = [
    "redacta posts con tu voz",
    "edita fotos y reels",
    "traduce a 100+ idiomas",
    "genera ideas de negocio",
  ];

  return (
    <section
      id="ia"
      data-testid="ai-travel"
      className="py-24 md:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-6 mb-20">
          <div className="col-span-12 md:col-span-7">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-coral">
              ◊ IA personal & viajes inteligentes
            </p>
            <h2 className="mt-5 font-serif text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tighter">
              IA que sirve.<br />
              <span className="italic">No que distrae.</span>
            </h2>
          </div>
          <p className="col-span-12 md:col-span-5 text-lg text-ink/75 leading-relaxed text-balance md:pt-10">
            Tu copiloto creativo y cultural. Está donde lo necesitas, silencioso donde no. Cero pop-ups. Cero sugerencias agresivas. Cero datos vendidos a terceros.
          </p>
        </div>

        {/* Asymmetric showcase */}
        <div className="grid grid-cols-12 gap-6 lg:gap-10">
          {/* AI personal card */}
          <div
            data-testid="ai-personal-card"
            className="col-span-12 md:col-span-7 relative overflow-hidden rounded-2xl border hairline bg-cream-deep/60 p-8 md:p-12 lg:p-16 lift"
          >
            <div className="flex items-center gap-3 mb-8">
              <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-ink-mid">
                IA personal
              </span>
              <span className="w-12 h-px bg-coral" />
              <span className="font-mono text-[10px] text-coral">activo</span>
            </div>

            <h3 className="font-serif text-4xl md:text-6xl leading-[1] tracking-tight max-w-xl">
              Una IA que escribe contigo, no por ti.
            </h3>

            <ul className="mt-10 space-y-4">
              {aiCapabilities.map((cap, i) => (
                <li key={cap} className="flex items-baseline gap-4 border-b hairline pb-3">
                  <span className="font-mono text-[10px] text-coral">0{i + 1}</span>
                  <span className="font-serif italic text-2xl md:text-3xl text-ink">
                    {cap}
                  </span>
                </li>
              ))}
            </ul>

            {/* Floating chip */}
            <div className="mt-10 inline-flex items-center gap-3 bg-ink text-cream rounded-full pl-3 pr-5 py-2">
              <span className="w-2 h-2 rounded-full bg-coral animate-shimmer" />
              <span className="font-mono text-[10px] uppercase tracking-[0.25em]">
                Powered by Claude · Gemini · GPT — tu eliges
              </span>
            </div>
          </div>

          {/* Travel card */}
          <div
            data-testid="ai-travel-card"
            className="col-span-12 md:col-span-5 lift"
          >
            <div className="img-reveal rounded-2xl overflow-hidden border hairline aspect-[5/6]">
              <img
                src={AI_NETWORK_IMG}
                alt="IA cultural y viajes inteligentes"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            <div className="mt-7">
              <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-coral">
                Viajes inteligentes ✦
              </p>
              <h3 className="mt-3 font-serif text-4xl md:text-5xl leading-tight">
                Recorre el mundo con un guía cultural en el bolsillo.
              </h3>
              <p className="mt-4 text-base text-ink/75 leading-relaxed">
                Apunta tu móvil a un monumento, una receta o una ciudad — Ovamx te cuenta su historia, su contexto y por qué importa. Conecta con locales, descubre rutas reales, traduce en tiempo real.
              </p>
            </div>

            <div className="mt-6 grid grid-cols-3 gap-4">
              {[
                { k: "100+", v: "idiomas" },
                { k: "180", v: "países" },
                { k: "AR", v: "modo cámara" },
              ].map((s) => (
                <div key={s.v} className="border hairline rounded-xl p-4 bg-white/45">
                  <div className="font-serif text-2xl">{s.k}</div>
                  <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink-mid mt-1">
                    {s.v}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
